import { PDFDownloadLink } from '@react-pdf/renderer';
import { SkillsMemberModel } from 'generated-types/skills/member';
import { NavigateFunction } from 'react-router-dom';
import { Button, IconButton, Loader } from 'rsuite';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import format from 'date-fns/format';

const HeaderPanelPreview = ({
    document,
    member,
    navigate,
    selectedMemberId,
    anonymous,
}: {
    document?: JSX.Element;
    member?: SkillsMemberModel;
    navigate: NavigateFunction;
    selectedMemberId?: number;
    anonymous?: boolean;
}) => (
    <>
        {document && member && (
            <PDFDownloadLink
                document={document}
                fileName={
                    anonymous
                        ? `Circles-CV-${format(new Date(), 'MM-yyyy')}`
                        : `Circles-CV-${member.firstname}-${member.lastname}-${format(new Date(), 'MM-yyyy')}`
                }
            >
                {({ loading }) =>
                    loading ? (
                        <Loader content="Creating link..." />
                    ) : (
                        <>
                            <IconButton
                                appearance="primary"
                                color="green"
                                icon={<FileDownloadIcon />}
                            >
                                Download PDF
                            </IconButton>{' '}
                        </>
                    )
                }
            </PDFDownloadLink>
        )}
        <Button
            onClick={() => {
                navigate(selectedMemberId ? `/resume/${selectedMemberId}` : '/resume');
            }}
        >
            Close
        </Button>
    </>
);

export default HeaderPanelPreview;
